import React from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import useStores from '../../../stores/useStore'
import { colors } from '../../../styles/colors'
import { useTranslation } from 'react-i18next'

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
`
const StyledItemWrapper = styled.div`
  //min-width: 230px;
  // margin-top: 5px;
  // flex: 0 0 230px;
  flex: 1 1 calc(40% - 8px); /* Ensures two columns */
  @media (max-width: 426px) {
    flex: 0;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  line-height: 1.4;
  max-width: ${(props) => (props.showJobFunction ? '690px' : '460px')};
  @media (max-width: 426px) {
    flex-direction: column;
  }
`

const StyledLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
`

const StyledValue = styled.div`
  color: ${colors.secondary};
`
const AssetData = observer((props) => {
  const { productsStore } = useStores()
  // const targetEmployee = useObserver(() => productsStore.targetEmployee)
  const targetEmployee = productsStore.targetEmployee
  const { t } = useTranslation()

  return (
    <>
      <StyledContainer {...props}>
        <StyledWrapper showJobFunction={props.showJobFunction}>
          {props.showJobFunction ? (
            <StyledItemWrapper>
              <StyledLabel>{t('assetOverlay:jobFunction')}</StyledLabel>
              <StyledValue className='value-color'>
                {productsStore.activities[0].displayName}&nbsp;
              </StyledValue>
            </StyledItemWrapper>
          ) : (
            ''
          )}
          <StyledItemWrapper>
            <StyledLabel>{t('assetFormMainData:number')}</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.personalNr}&nbsp;
            </StyledValue>
          </StyledItemWrapper>
          <StyledItemWrapper>
            <StyledLabel>{t('OrderSubheader:costcenter')}</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.costCenter &&
                targetEmployee.costCenter.displayName}
              &nbsp;
            </StyledValue>
          </StyledItemWrapper>
          <StyledItemWrapper>
            <StyledLabel>{t('OrderSubheader:orgaUnit')}</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.office && targetEmployee.office.displayName}&nbsp;
            </StyledValue>
          </StyledItemWrapper>
        </StyledWrapper>
      </StyledContainer>
    </>
  )
})

export default AssetData
